export default function IndexSection() {
  return (
    <section id="index" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            分类索引
          </h2>
          <p className="text-sm text-foreground-500">按分类快速浏览51漫画网全部漫画资源</p>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-3 gap-4">
          {[
            { label: '热血格斗', count: '3260部', icon: 'ri-flashlight-line' },
            { label: '恋爱甜宠', count: '2890部', icon: 'ri-heart-line' },
            { label: '奇幻冒险', count: '2410部', icon: 'ri-compass-3-line' },
            { label: '悬疑推理', count: '1830部', icon: 'ri-search-eye-line' },
            { label: '搞笑日常', count: '2150部', icon: 'ri-emotion-laugh-line' },
            { label: '科幻未来', count: '1560部', icon: 'ri-rocket-line' },
            { label: '恐怖灵异', count: '980部', icon: 'ri-ghost-line' },
            { label: '武侠仙侠', count: '1720部', icon: 'ri-sword-line' },
            { label: '运动竞技', count: '890部', icon: 'ri-basketball-line' },
          ].map((item) => (
            <a
              key={item.label}
              href="#cards"
              onClick={(e) => {
                e.preventDefault();
                const el = document.getElementById('cards');
                if (el) {
                  const top = el.getBoundingClientRect().top + window.scrollY - 80;
                  window.scrollTo({ top, behavior: 'smooth' });
                }
              }}
              className="flex items-center gap-3 bg-background-50 rounded-xl p-4 hover:bg-background-50 transition-colors cursor-pointer group"
            >
              <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-100/80 text-primary-600 flex-shrink-0 group-hover:bg-primary-500 group-hover:text-background-50 transition-colors duration-200">
                <i className={`${item.icon} text-lg`}></i>
              </div>
              <div className="flex-1 min-w-0">
                <div className="text-sm font-medium text-foreground-800">{item.label}</div>
                <div className="text-xs text-foreground-500">{item.count}</div>
              </div>
              <div className="w-5 h-5 flex items-center justify-center text-foreground-400 flex-shrink-0">
                <i className="ri-arrow-right-s-line text-sm"></i>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}